var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.field.component,_vm._g({ref:_vm.fieldName,tag:"Component",attrs:{"field":_vm.field,"fieldName":_vm.fieldName,"model":_vm.model,"contexts":_vm.field.contexts,"isFromLibraryPage":_vm.isFromLibraryPage}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }